import React, { useState, useContext } from "react"
import { RootContext } from 'RootContext';

//core components
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import Button from "@material-ui/core/Button"
import Card from "components/Card/Card.js"
import CardBody from "components/Card/CardBody.js"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import FormControl from '@material-ui/core/FormControl';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import MenuItem from "@material-ui/core/MenuItem"
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography"

//Pegaso components
import SettingsTableOkSaved from "views/Settings/SettingsTableOkSaved"

//import CSS
import { useDeviceStylesText } from "styles/device/deviceCss.js"

export default function SupportDialog(props) {
  const { t, } = useContext(RootContext)
  const { buttonWord, endJobId, dialogMsg, titleWord, handleSave, openPanel, openDialog, setOpenPanel, setEndJobId, setStartJobId, setOpenDialog, startJobId } = props
  const classesText = useDeviceStylesText()

  const currentYear = new Date().getFullYear()
  const [isSaving, setIsSaving] = useState(false)
  const [year, setYear] = useState(currentYear)
  const startYear = currentYear - 2
  const selectOptionsJobYear = [
    {
      value: "",
      text: "",
    },
  ]
  for (let i = startYear; i <= currentYear; i++) {
    const item = { value: i, text: i }
    selectOptionsJobYear.push(item)
  }





  /*
    HANDLER
  */

  const handleChangeValue = (setter) => (event) => {
    let value = event.target.value === "" ? 0 : parseInt(event.target.value)
    setter(value)
  }

  const handleClickSave = () => {
    setIsSaving(true)
    handleSave()
    setIsSaving(false)
  }


  //Chiude o apre il pannello contenente i supplier
  const changeOpenPanel = () => {
    var value = !openPanel
    setOpenPanel(value)
  }

  //Close
  const handleClose = () => {
    setOpenDialog(false)
  }
  var disabledSave = startJobId > endJobId || endJobId < startJobId || startJobId === "" || endJobId === ""

  return (
    <div>

      {/*PANNELLO RISTAMPA*/}
      <Accordion expanded={openPanel} onChange={changeOpenPanel} >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography align="center" style={{ width: "100%", alignItems: "center" }}><u>{t(titleWord).toUpperCase()}</u></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Card>
            <CardBody>
              <GridContainer>

                <GridItem xs={12} sm={12} md={3}>
                  <FormControl style={{ minWidth: 120 }}>
                    <TextField
                      select
                      id={"year"}
                      name={"year"}
                      label={t("10117")}
                      value={year}
                      onChange={(event) => setYear(event.target.value)}
                    >
                      {selectOptionsJobYear.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.text}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </GridItem>


                <GridItem xs={12} sm={12} md={3}>
                  <TextField
                    id={"startJobId"}
                    label={t("10480")}
                    error={startJobId > endJobId}
                    value={startJobId}
                    className={classesText.textField}
                    onChange={handleChangeValue(setStartJobId)}
                    helperText={startJobId > endJobId ? t("10482") : ""}

                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <TextField
                    id={"endtJobId"}
                    label={t("10481")}
                    error={endJobId < startJobId}
                    value={endJobId}
                    className={classesText.textField}
                    onChange={handleChangeValue(setEndJobId)}
                    helperText={endJobId < startJobId ? t("10483") : ""}
                  />
                </GridItem>

                {/*BOTTONE SALVA*/}
                <GridItem xs={12} sm={12} md={3}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleClickSave}
                    disabled={disabledSave}
                  >
                    {t(buttonWord)}
                  </Button>
                </GridItem>

              </GridContainer>

              <SettingsTableOkSaved
                dialogMsg={dialogMsg}
                handleClose={handleClose}
                isSaving={isSaving}
                openDialog={openDialog}
              />

            </CardBody>
          </Card>
        </AccordionDetails>
      </Accordion>



    </div>
  )
}
